;(function() {
/* @ngInject */
function ZalozenieZivnostiObjednaneController(CompletedOrderService, $location, $window, $filter, ModalInfo, $scope, Helpers, SigniService){
  let vm = this;
  let server = CompletedOrderService;

  vm.generateDocs = generateDocs;
  vm.generateForeignerDocs = generateForeignerDocs;
  vm.getFileName = Helpers.getFileName;
  vm.payment = "";
  vm.errorPayment = false;
  vm.showMovement = false;
  vm.isUnzipFiles = true;
  vm.showLoading = false;
  vm.showProforma = false;
  vm.hideDownloadDocuments = true;
  vm.downloadLabel = $filter("translate")('payments.documents.zivnost.zaloz');

  $scope.$watch('vm.payment', function() {
    if(vm.payment !== "")
      vm.errorPayment = false;
  }, true);

  server.getCompletedOrderData().then(onPaymentInfoLoad);

  SigniService.handleSigniResponse();

  let dataLayerStorage = $window.localStorage.getItem('dataLayer');
  $window.localStorage.removeItem('dataLayer');
  var dataLayer = $window.dataLayer = $window.dataLayer || [];
  if (dataLayerStorage)
    dataLayer.push(JSON.parse(dataLayerStorage));

  function onPaymentInfoLoad(payment) {
    if(payment) {
      vm.orderId = payment.orderId;
      vm.price = payment.price;
      vm.hideDownloadDocuments = payment.hideDownloadDocuments;
      vm.paymentData = payment;

      if (Date.now() < new Date("2021-03-01") && vm.paymentData.nameForeignerAtt.length > 0 && payment.price !== payment.paidAmount)
        ModalInfo("sro.actualInfoTitle", "sro.actualInfoText", "buttons.understand")
            .add()
            .result
            .then();

    } else {
      $window.location = "krok1";
    }
  }

  function generateDocs() {
    vm.showLoading = true;
    server.regenerateDocs().then(() => {
      server.getCompletedOrderData().then((p) => {
        if(p.documentsLink) {
          let url = '/objednavka/detail?o=' + p.documentsLink;
          $window.location = url;
        }
      });
      vm.showLoading = false;
    });
  }

  function generateForeignerDocs() {
    vm.showLoading = true;
    server.regenerateForeignerDocs().then(() => {
      server.getCompletedOrderData().then((p) => {
        if(p.documentsLink) {
          let url = '/objednavka-cudzinci/detail?o=' + p.documentsLink;
          $window.location = url;
        }
      });
      vm.showLoading = false;
    });
  }
}

angular.module("firmaren")
  .controller("ZalozenieZivnostiObjednaneController", ZalozenieZivnostiObjednaneController);
}());
